<div class="form-group row" *ngIf="show">
    <label class="col-sm-8 col-form-label text-bold text-right" for="enable_statistics" translate>
        Enable Statistics
    </label>
    <div class="col-sm-40 pl-4">
        <form-field-material-switch name="enable_statistics"
                                    [(ngModel)]="canUse"
                                    (ngChange)="onChangeValue()">
        </form-field-material-switch>
    </div>
</div>

<div class="form-group row" *ngIf="show && canUse">
    <label class="col-sm-8 col-form-label text-bold text-right" for="cookieless_tracking" translate>
        Enable Cookieless Tracking
    </label>
    <div class="col-sm-40 pl-4">
        <form-field-material-switch name="cookieless_tracking"
                                    [(ngModel)]="cookielessTracking"
                                    (ngChange)="onChangeCookielessTracking()">
        </form-field-material-switch>
    </div>
</div>

<div class="form-group row" *ngIf="show && canUse">
    <label class="col-sm-8 col-form-label text-bold text-right" for="document_tracking" translate>
        Enable Document Tracking
    </label>
    <div class="col-sm-40 pl-4">
        <form-field-material-switch name="document_tracking"
                                    [(ngModel)]="documentTracking"
                                    (ngChange)="onChangeDocumentTracking()">
        </form-field-material-switch>
    </div>
</div>

<div class="form-group row" *ngIf="show && canUse && documentTracking">
    <label class="col-sm-8 col-form-label text-right text-bold" for="document_class" translate>Document Class</label>
    <div class="col-sm-40">
        <input class="form-control"
               id="document_class"
               type="text"
               aria-describedby="document_class_help"
               name="document_class"
               (ngModelChange)="onChangeDocumentClass()"
               [(ngModel)]="documentClass"/>
        <small id="document_class_help" class="form-text text-muted" translate>
            Search for links, that are associated with class names and contains below mentioned class names.
        </small>
    </div>
</div>

<div class="form-group row" *ngIf="show && canUse && documentTracking">
    <label class="col-sm-8 col-form-label text-right text-bold" for="document_ignore_class" translate>Document Ignore Class</label>
    <div class="col-sm-40">
        <input class="form-control"
               id="document_ignore_class"
               type="text"
               aria-describedby="document_ignore_class_help"
               name="document_class"
               (ngModelChange)="onChangeDocumentIgnoreClass()"
               [(ngModel)]="documentIgnoreClass"/>
        <small id="document_ignore_class_help" class="form-text text-muted" translate>
            Exclude links that contains class name
        </small>
    </div>
</div>
<div *ngIf="show && canUse && documentTracking" class="mt-6">
    <p class="text-bold" translate>
        Acquia Web Governance will automatically detect a download as a click on a link that ends with one of the following file extensions (please be aware, that the extensions are case sensitive )
    </p>
    <div class="form-group row" *ngFor="let ext of documentExts; let i = index; trackBy: trackByIndex">
        <label class="col-sm-8 col-form-label text-right text-bold" for="document_ext[{{i}}]" translate>Document Extension</label>
        <div class="col-sm-36">
            <input class="form-control"
                   id="document_ext[{{i}}]"
                   type="text"
                   name="document_class"
                   (ngModelChange)="onChangeDocumentExtension()"
                   [(ngModel)]="documentExts[i]"/>
        </div>
        <div class="pl-sm-0 col-sm-4 text-right">
            <button type="button"
                    (click)="removeExtension(i)"
                    class="btn btn-border-radius btn-secondary"
                    [attr.aria-label]="'Remove Extension Name' | translate"
                    [ngbTooltip]="'Remove Extension Name' | translate"
                    triggers="focus:blur mouseenter:mouseleave">
                <span class="fas fa-trash-alt" aria-hidden="true"></span>
            </button>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col offset-sm-8">
            <button type="button"
                    class="btn btn-border-radius btn-secondary"
                    (click)="addExtension()"
                    [attr.aria-label]="'Add Extension Name' | translate"
                    [ngbTooltip]="'Add Extension Name' | translate"
                    triggers="focus:blur mouseenter:mouseleave">
                <span class="fas fa-plus" aria-hidden="true"></span>
            </button>
        </div>
    </div>
</div>
